export const colonSeparator = ':';
export const semicolonSeparator = ';';
export const dotSeparator = '.';

export const BASKET_COOKIE_EXPIRED = 30;